class PaginationLoadMore {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', this.handleLoadMore.bind(this));
  }

  async handleLoadMore(event) {
    const button = event.target.closest('.pagination__load-more-button');
    if (!button) return;

    event.preventDefault();
    
    const nextUrl = button.dataset.nextUrl;
    const currentPage = parseInt(button.dataset.currentPage);
    const totalPages = parseInt(button.dataset.pages);
    
    if (!nextUrl) return;

    // Show loading state
    this.setLoadingState(button, true);

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the container that holds your products/items
      // Adjust this selector based on your collection template
      const newItems = doc.querySelectorAll('.product-grid .grid__item, .collection .grid__item');
      const currentContainer = document.querySelector('.product-grid .grid, .collection .grid');
      
      if (newItems.length > 0 && currentContainer) {
        // Append new items
        newItems.forEach(item => {
          currentContainer.appendChild(item.cloneNode(true));
        });
        
        // Update button for next page
        const nextPage = currentPage + 1;
        if (nextPage < totalPages) {
          const newNextUrl = nextUrl.replace(/page=\d+/, `page=${nextPage + 1}`);
          button.dataset.nextUrl = newNextUrl;
          button.dataset.currentPage = nextPage;
          
          // Update the info text
          const info = button.closest('.pagination-wrapper').querySelector('.pagination__info');
          if (info) {
            const newItemCount = document.querySelectorAll('.product-grid .grid__item, .collection .grid__item').length;
            // You might need to adjust this based on your pagination data
            info.textContent = `Showing ${newItemCount} items`;
          }
        } else {
          // No more pages, hide the button
          button.closest('.pagination-wrapper').style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error loading more items:', error);
      // Show error message
      this.showError(button);
    } finally {
      this.setLoadingState(button, false);
    }
  }

  setLoadingState(button, isLoading) {
    const text = button.querySelector('.pagination__load-more-text');
    const loading = button.querySelector('.pagination__loading');
    
    if (isLoading) {
      text.classList.add('hide');
      loading.classList.remove('hide');
      button.disabled = true;
    } else {
      text.classList.remove('hide');
      loading.classList.add('hide');
      button.disabled = false;
    }
  }

  showError(button) {
    const text = button.querySelector('.pagination__load-more-text');
    text.textContent = 'Error loading more items. Please try again.';
    setTimeout(() => {
      text.textContent = 'Load More';
    }, 3000);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new PaginationLoadMore());
} else {
  new PaginationLoadMore();
}